module.exports = __webpack_public_path__ + "img/screenBackDark.c055b239.png";